import { css } from "styled-components";

export const focusOutlineStyles = (color = "currentColor") =>
  css`
    &:focus {
      outline: 1px solid ${color};
      outline-offset: ${({ theme }) => theme.spacing[1]};
    }
  `;
